import {
  SET_ACTION_TO_HANDLE_UNSAVED_WORK,
  SET_APP_LOADED,
  SET_GLOBAL_ERROR,
  SET_PARAMS,
  SET_USER,
  THERE_IS_UNSAVED_WORK,
} from '@/store/mutation-types'
import { IMutation, IMutationWithoutPayload } from '@/store/types/mutation'
import { IParameters } from '@/types/parameters'
import { IUser } from '@/types/user'

import { THERE_IS_NOT_UNSAVED_WORK } from '@/store/mutation-types'
import { IRootStoreState } from '@/store/types'
import { CLOSE_CONFIRM_ROUTE_CHANGE_DIALOG, OPEN_CONFIRM_ROUTE_CHANGE_DIALOG } from './mutation-types'

const mutationSetUser: IMutation<IRootStoreState, IUser | undefined> = (state, user) => {
  state.user = user
}

const mutationSetParams: IMutation<IRootStoreState, IParameters | undefined> = (state, parameters) => {
  state.parameters = parameters
}

const mutationSetAppIsLoading: IMutation<IRootStoreState, boolean> = (state, isLoading) => {
  state.isLoadingApp = isLoading
}

const mutationSetGlobalError: IMutation<IRootStoreState, string | undefined> = (state, error) => {
  state.globalError = error
}

const mutationThereIsUnsavedWork: IMutationWithoutPayload<IRootStoreState> = (state) => {
  state.isThereWorkToBeSaved = true
}

const mutationThereIsNotUnsavedWork: IMutationWithoutPayload<IRootStoreState> = (state) => {
  state.isThereWorkToBeSaved = false
}

const mutationCloseConfirmRouteChangeDialog: IMutationWithoutPayload<IRootStoreState> = (state) => {
  state.displayContirmRouteChangeDialog = false
}
const mutationOpenConfirmRouteChangeDialog: IMutation<IRootStoreState, string> =
(state, pathToGoIfModalIsConfirmed) => {
  state.isThereWorkToBeSaved = false
  state.displayContirmRouteChangeDialog = true
  state.pathToGoIfModalIsConfirmed = pathToGoIfModalIsConfirmed
}

const mutationSetActionToHandleUnsavedWork: IMutation<IRootStoreState, () => boolean> =
  (state, actionToHandleUnsavedWork) => {
    state.actionToHandleUnsavedWork = actionToHandleUnsavedWork
  }

export default {
  [SET_USER]: mutationSetUser,
  [SET_PARAMS]: mutationSetParams,
  [SET_APP_LOADED]: mutationSetAppIsLoading,
  [SET_GLOBAL_ERROR]: mutationSetGlobalError,
  [THERE_IS_UNSAVED_WORK]: mutationThereIsUnsavedWork,
  [THERE_IS_NOT_UNSAVED_WORK]: mutationThereIsNotUnsavedWork,
  [SET_ACTION_TO_HANDLE_UNSAVED_WORK]: mutationSetActionToHandleUnsavedWork,
  [OPEN_CONFIRM_ROUTE_CHANGE_DIALOG]: mutationOpenConfirmRouteChangeDialog,
  [CLOSE_CONFIRM_ROUTE_CHANGE_DIALOG]: mutationCloseConfirmRouteChangeDialog,
}
